/**
 * Created by charnjeetelectrovese@gmail.com on 2/3/2020.
 */
import { createBrowserHistory } from "history";
export default createBrowserHistory();
